export const appRootId = "app"

export const appHead = {"meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"viewport","content":"width=device-width,initial-scale=1.0"},{"name":"format-detection","content":"email=no"}],"link":[{"rel":"preconnect","href":"https://user.openalex.org","crossorigin":""},{"rel":"preconnect","href":"https://api.openalex.org","crossorigin":""},{"rel":"dns-prefetch","href":"https://user.openalex.org"},{"rel":"dns-prefetch","href":"https://api.openalex.org"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"icon","href":"/tricon-outlined.png","type":"image/png"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Dosis:wght@200..800&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&family=Roboto:ital,wght@0,100..900;1,100..900&display=swap"}],"style":[],"script":[{"innerHTML":"(function(){var o=console.error;console.error=function(){var a=arguments;if(typeof a[0]==='string'&&a[0].indexOf('ResizeObserver loop')>-1)return;o.apply(console,a)};window.addEventListener('error',function(e){if(e.message&&e.message.indexOf('ResizeObserver loop')>-1){e.stopImmediatePropagation();e.preventDefault();return false}},true)})();"},{"defer":true,"data-domain":"openalex.org","src":"https://plausible.io/js/script.file-downloads.outbound-links.pageview-props.tagged-events.js"},{"innerHTML":"window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) }"},{"src":"https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit","async":true,"defer":true},{"id":"ze-snippet","src":"https://static.zdassets.com/ekr/snippet.js?key=f448c93c-e2e1-4d7c-b344-683a586e69f7","tagPosition":"bodyClose"},{"innerHTML":"\n    // Zendesk Widget Setup\n    window.zE = window.zE || function() { (zE.q = zE.q || []).push(arguments); };\n    // Wait for the widget to load before setting user details\n    zE('webWidget:on', 'open', function() {\n        zE('webWidget', 'identify', {\n        name: vm.$store.state.user.name,\n        email: vm.$store.state.user.email,\n        });\n    });\n    zE('webWidget', 'updateSettings', {\n        webWidget: {\n            contactForm: {\n                attachments: false,\n                title: { '*': \"Send us Feedback\"},\n            }\n        }\n    });\n","tagPosition":"bodyClose"}],"noscript":[{"innerHTML":"<p><strong>OpenAlex needs JavaScript to run in your browser.</strong></p><p>OpenAlex is a free and open catalog of the world's research. To get the data without a browser, use the OpenAlex API: <a href=\"https://help.openalex.org/\">help.openalex.org</a> explains how, and <a href=\"https://help.openalex.org/llms.txt\">help.openalex.org/llms.txt</a> lists every docs page.</p>","tagPosition":"bodyOpen"}],"htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootTag = "div"

export const appRootAttrs = {"id":"app"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const componentIslandsActive = false

export const payloadExtraction = false

export const prefetchPreloadTags = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#app'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true

export const clientNodePlaceholder = false

export const tracingChannelNuxt = false

export const runtimeCompiler = false

export const hasPluginDependencies = true

export const hasParallelPlugins = false

export const hasPluginHooks = false

export const hasIslandOptOutPlugins = false